'use client';
import Conditional from '@next-app/components/Conditional';
import SkeletonUI from '@next-app/components/Skeleton/Skeleton';
import {
  selectIsCheckoutDetailsLoaded,
  selectIsPaymentMethodStep,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';

const PaymentCard = dynamic(() => import('../PaymentCard/PaymentCard'), {
  ssr: true,
  loading: () => <SkeletonUI width={'100%'} height={30} />,
});

const PaymentSection = () => {
  const isCheckoutDetailsLoaded = useSelector(selectIsCheckoutDetailsLoaded);
  const isPaymentMethodStep = useSelector(selectIsPaymentMethodStep);
  return (
    <>
      <Conditional if={!isCheckoutDetailsLoaded}>
        <SkeletonUI width={'100%'} height={30} />
      </Conditional>
      <Conditional if={isCheckoutDetailsLoaded && isPaymentMethodStep}>
        <section id="payment-section" className="my-ll-5 rounded-bottom">
          <PaymentCard />
        </section>
      </Conditional>
    </>
  );
};

export default PaymentSection;
